// Who holds the work.
//
// This is not what a site is called. lux.partners is called Lux Industries Inc and
// lux.cash is called Lux Cash; both are held by the same company. Keeping the
// two as one string is what let a rename of the company rewrite the titles of
// the sites, so they are separate values with separate homes: a site names
// itself in its own metadata, and every line about ownership reads from here.

export const holder = {
  name: 'Lux Industries Inc',
  form: 'Delaware C corporation',
  since: 2020,
} as const

// The notice is derived, never stored. A stored one carries a year that is
// wrong every January and a copy of the name that drifts from it.
export const copyright = (year: number = new Date().getFullYear()): string =>
  `Copyright © ${year > holder.since ? `${holder.since}–${year}` : holder.since}` +
  ` ${holder.name}. All rights reserved.`
